/* eslint-disable max-len */
/* eslint-disable prettier/prettier */
// Auto-generated config file
// Do not edit manually

const currentOrgConfig = {
  "LOGO": {
    "path": "assets/branding/bmcc-logo.svg",
    "css": {
      "marginBottom": "1.5px"
    }
  },
  "FAQ": [
    {
      "question": "How long will the verification process take?",
      "answer": "After successfully submitting your documents, please allow 5 to 12 business days for your institution to verify them. If the documents you submitted are incomplete, the verification process will take longer."
    },
    {
      "question": "How will my verification reach to BMCC CUNY?",
      "answer": "You will be notified via text message or email once verification is successful, and your report will be immediately uploaded to the BMCC CUNY platform. No further action is required on your part."
    },
    {
      "question": "How soon will I see my BMCC CUNY account updated after the file is shared with BMCC CUNY?",
      "answer": "Once sent to BMCC CUNY, your verification documents will appear on the BMCC CUNY portal within 2 business days",
      "includesHTML": true
    },
    {
      "question": "Why is the verification fee different for different candidates?",
      "answer": "Verification fees vary by individual, depending on the number of documents submitted and the issuing institution"
    }
  ],
  "INSTRUCTIONS": [
    {
      "label": "Step 1: Log in to your web wallet",
      "type": "ul",
      "description": [
        "Enter your cell phone number to receive a verification code.",
        "Enter the code received on your phone via text (SMS) or WhatsApp.",
        "Note: This can be any cell phone number where you wish to receive future communications."
      ]
    },
    {
      "label": "Step 2: Identity Verification - Passport",
      "type": "ul",
      "description": [
        "Scan the photo page of your passport using your webcam or mobile device.",
        "Once verified, you will automatically proceed to the next step."
      ]
    },
    {
      "label": "Step 3: Upload your documents",
      "type": "ul",
      "description": [
        "You must complete at least one of the three education checks: 1) High School (10th Grade), 2) High School Diploma (12th Grade), or 3) College Degree.",
        "Any remaining categories should be marked as \"skipped\" by clicking the verification and then selecting the skip button.",
        "Ensure all uploaded documents are high-quality and all details are clearly legible to ensure faster processing."
      ]
    },
    {
      "label": "Step 3a: Upload High School Transcript",
      "type": "ul",
      "description": [
        "Enter the required details under the High School Certificate section.",
        "Click the option to upload your transcript.",
        "Upload a scanned copy of your transcript in PDF format."
      ]
    },
    {
      "label": "Step 3b: Upload High School Diploma",
      "type": "ul",
      "description": [
        "Enter the required details for your High School Diploma.",
        "Select the file containing your final grades and upload it."
      ]
    },
    {
      "label": "Step 3c: Upload Degree (Diploma and All Semester Transcripts)",
      "type": "ul",
      "description": [
        "Proceed to the section for uploading proof of your degree.",
        "Upload a copy of your diploma and transcripts for all semesters.",
        "If you have multiple degrees to add, select the \"Add Another Degree\" option."
      ]
    },
    {
      "label": "Step 4: Review Uploaded Documents",
      "type": "ul",
      "description": [
        "Ensure that all uploaded documents are accurate and legible.",
        "Carefully review the information associated with each degree."
      ]
    },
    {
      "label": "Step 5: Proceed to Payment",
      "type": "ul",
      "description": [
        "After successfully uploading all required documents, click the Pay button at the bottom. Use your preferred payment method to complete the process.",
        "Total costs may vary by individual depending on the number of documents submitted and the educational institution from which you graduated."
      ]
    }
  ]
} as const;

export default currentOrgConfig;
